import React from 'react';
import { Navigate } from 'react-router-dom';
import { pagesAccess } from './accessMap';
import { firstAccessiblePage } from './access';
import SignInPage from '../pages/SignIn.page';
import RecentOrdersPage from '../pages/RecentOrders.page';
import OrderDetailsPage from '../pages/OrderDetails.page';
import OrdersByDatePage from '../pages/OrdersByDate.page';
import OrdersByVendorPage from '../pages/OrdersByVendor.page';
import OrdersByVehiclePage from '../pages/OrdersByVehicle.page';
import OrdersByPartTypePage from '../pages/OrdersByPartType.page';
import OrdersByStatusPage from '../pages/OrdersByStatus.page';
import OrdersByWebsitePage from '../pages/OrdersByWebsite.page';
import OrdersByStatePage from '../pages/OrdersByState.page';
import OrdersByDmaPage from '../pages/OrdersByDma.page';
import OrdersByPaymentTypePage from '../pages/OrdersByPaymentType.page';
import { IUser } from '../model/IUser';

export interface IMapItem {
  path: string;
  element: React.ReactNode;
  children?: IMapItem[];
}

export const siteMap = (
  originalAddress: string,
  getPageAccess: (pageUrl: keyof typeof pagesAccess) => boolean,
  user?: IUser | null,
): IMapItem[] => [
  {
    // -- Whatever this user can open, rather than a fixed page: a role with no
    // -- Recent Orders used to be redirected to sign in, which sent it back
    // -- here, forever.
    path: '/',
    element: (
      (() => {
        const landing = firstAccessiblePage(getPageAccess);
        return landing
          ? <Navigate to={landing} />
          : <Navigate to='/oauth/signIn?original-url=/' />;
      })()
    ),
  },

  // --
  // -- Orders routes
  // --
  {
    path: '/orders',
    element: (getPageAccess('/orders') ? <RecentOrdersPage /> : <Navigate to='/oauth/signIn?original-url=/orders' />),
  },
  {
    path: '/orders/:orderId',
    element: (getPageAccess('/orders') ? <OrderDetailsPage /> : <Navigate to='/oauth/signIn?original-url=/orders' />),
  },

  // --
  // -- Categorised views. Kept off /orders/... on purpose: /orders/by-date
  // -- would sit next to /orders/:orderId and read as an order number.
  // --
  {
    path: '/orders-by-date',
    element: (getPageAccess('/orders-by-date') ? <OrdersByDatePage /> : <Navigate to='/oauth/signIn?original-url=/orders-by-date' />),
  },
  {
    path: '/orders-by-vendor',
    element: (getPageAccess('/orders-by-vendor') ? <OrdersByVendorPage /> : <Navigate to='/oauth/signIn?original-url=/orders-by-vendor' />),
  },
  {
    path: '/orders-by-vehicle',
    element: (getPageAccess('/orders-by-vehicle') ? <OrdersByVehiclePage /> : <Navigate to='/oauth/signIn?original-url=/orders-by-vehicle' />),
  },
  {
    path: '/orders-by-part-type',
    element: (getPageAccess('/orders-by-part-type') ? <OrdersByPartTypePage /> : <Navigate to='/oauth/signIn?original-url=/orders-by-part-type' />),
  },
  {
    path: '/orders-by-status',
    element: (getPageAccess('/orders-by-status') ? <OrdersByStatusPage /> : <Navigate to='/oauth/signIn?original-url=/orders-by-status' />),
  },
  {
    path: '/orders-by-website',
    element: (getPageAccess('/orders-by-website') ? <OrdersByWebsitePage /> : <Navigate to='/oauth/signIn?original-url=/orders-by-website' />),
  },
  {
    path: '/orders-by-state',
    element: (getPageAccess('/orders-by-state') ? <OrdersByStatePage /> : <Navigate to='/oauth/signIn?original-url=/orders-by-state' />),
  },
  {
    path: '/orders-by-dma',
    element: (getPageAccess('/orders-by-dma') ? <OrdersByDmaPage /> : <Navigate to='/oauth/signIn?original-url=/orders-by-dma' />),
  },
  {
    path: '/orders-by-payment-type',
    element: (getPageAccess('/orders-by-payment-type') ? <OrdersByPaymentTypePage /> : <Navigate to='/oauth/signIn?original-url=/orders-by-payment-type' />),
  },

  // --
  // -- Ouath routes
  // --
  {
    path: '/oauth/signIn',
    element: <SignInPage />,
  },

  // --
  // -- Other routes
  // --
  {
    path: '*',
    element: <Navigate to='/' />,
  },
];

